import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const saasPlgTemplate: FunnelTemplate = {
  id: "saas-plg",
  serviceLine: "other",
  recommendedBands: ["growth", "enterprise"],
  pdfAccentColor: "#0EA5E9",
  defaultTrafficChannels: [
    { id: "google_organic", label: "Google Organic",  monthlyVisitors: 500, acquisitionType: "organic" },
    { id: "google_ads",     label: "Google Ads",      monthlyVisitors: 200, acquisitionType: "cpc", cpc: 3.50 },
    { id: "linkedin",       label: "LinkedIn",        monthlyVisitors: 150, acquisitionType: "organic" },
    { id: "review_sites",   label: "Review Sites",    monthlyVisitors: 100, acquisitionType: "organic" },
    { id: "referral",       label: "Referral",        monthlyVisitors: 80,  acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "landing-page",          conversionRate: 25, isEditable: true,  stageType: "landing-page" },
    { id: "pricing-page",          conversionRate: 12, isEditable: true,  stageType: "landing-page" },
    { id: "free-trial",            conversionRate: 70, isEditable: true,  stageType: "opt-in-page" },
    { id: "onboarding-checklist",  conversionRate: 50, isEditable: true,  stageType: "email-sequence" },
    { id: "activation-event",      conversionRate: 55, isEditable: true,  stageType: "custom" },
    { id: "in-app-upgrade",        conversionRate: 5,  isEditable: true,  stageType: "upsell" },
    { id: "order-form",            conversionRate: 80, isEditable: false, stageType: "order-form" },
  ],
};
